import { Series, Title } from 'types';
import { titlePhotoPath } from 'sdk/src/helpers/title';
import BooksMosaic from '@/components/books-mosaic';
import styles from '@/styles/components/tiles/series.module.scss';
import Card from '@/components/card';
import Heading from '@/components/typography/heading';
import { Box } from '@/components/layout/box';
import Text from '@/components/typography/text';
import { Flex } from '@/components/layout/flex';
import Link from 'next/link';
import Firebase from '@/clients/firebase/firebase-react-query';

export interface SeriesTileProps {
  series: Series;
}
export default function ClientSeriesTile({ series }: SeriesTileProps) {
  const titleIds = series?.titles?.map((t) => t.id) ?? [];

  const { data } = Firebase<Title>().fetchDataFromIds(titleIds, 'titles', {
    enabled: Boolean(titleIds?.length),
  });

  const imagePaths = data?.map(titlePhotoPath)?.filter(Boolean)?.slice(0, 3);

  if (!imagePaths?.length) return null;

  return (
    <Card p={1} className={styles.container}>
      <Link href={`/series/${series.id}`}>
        <BooksMosaic bookImagePaths={imagePaths} disableClick />
        <Flex direction="row" align="flex-end" justify="space-between">
          <Box>
            <Heading as="h3" size="base">
              {series.seriesTitle}
            </Heading>
            <Text size="small">by {series.authors?.[0]?.name}</Text>
          </Box>
          <Text color="copy" size="small">
            {series.titles?.length} books
          </Text>
        </Flex>
      </Link>
    </Card>
  );
}
